/**
 * Jun-2026 (User-Wunsch) — Externer Store für die Händler-Badge-Zähler
 * (offene Werkstatt-Aufträge + nie gezählte Fahrzeuge). Hält die Werte über
 * Komponenten hinweg synchron. Quellen:
 *   1. Initial-Fetch beim Login (`useDealerQuickCounts`).
 *   2. WebSocket-Event "dealer_quick_counts_changed" (`useUserNotifications`).
 */
let counts = { workshop_open: 0, inventory_uncounted: 0, email_outbox_pending: 0, email_unread: 0 };
const listeners = new Set();

export function setDealerQuickCounts(next) {
    if (!next || typeof next !== "object") return;
    counts = {
        workshop_open: typeof next.workshop_open === "number" ? next.workshop_open : counts.workshop_open,
        inventory_uncounted: typeof next.inventory_uncounted === "number" ? next.inventory_uncounted : counts.inventory_uncounted,
        email_outbox_pending: typeof next.email_outbox_pending === "number" ? next.email_outbox_pending : counts.email_outbox_pending,
        email_unread: typeof next.email_unread === "number" ? next.email_unread : counts.email_unread,
    };
    listeners.forEach((l) => { try { l(); } catch (_) { /* ignore */ } });
}

export function getDealerQuickCounts() {
    return counts;
}

export function subscribeDealerQuickCounts(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
